import React, { useState, useEffect, useRef } from "react";
import {
  TableBody,
  TableRow,
  TableCell,
  InputAdornment,
} from "@material-ui/core";
import useTable from "../useTable";
import { Dimmer } from "../spinner";
import { Mensaje, MensajeSiNo } from "../mensajes";
import axios from "axios";
import { ClasificadorMinas } from "./modalClasificadorminas";
import { Toasts } from "../toasts";

const TablaClaseMinas = (props) => {
  var op = require("../../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const accclaseminas = JSON.parse(localStorage.getItem("accclaseminas"));

  const headCells = [
    {
      id: "codigo",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-code">
          {" "}
          CÓDIGO
        </i>
      ),
      textAlign: "center",
      fontFamily: "georgia",
    },
    {
      id: "Descripción",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-signature">
          {" "}
          DESCRIPCIÓN
        </i>
      ),
      textAlign: "center",
      fontFamily: "georgia",
    },
    {
      id: "Código Clase",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-code-branch">
          {" "}
          CÓDIGO CLASE
        </i>
      ),
      textAlign: "center",
      fontFamily: "georgia",
    },
    {
      id: "opciones",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-cogs">
          {" "}
          OPCIONES
        </i>
      ),
      textAlign: "center",
      fontFamily: "georgia",
    },
  ];

  const [mostrar2, setMostrar2] = useState(false);
  const [mostrar4, setMostrar4] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [clase, setClase] = useState([]);
  const [operacion, setOperacion] = useState(1);
  const txtBuscador = useRef();
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: "",
    titulo: "",
  });
  const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else
          return items.filter((x) => {
            if (
              x.idclaseminas.includes(target.value) ||
              x.descripcion
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              x.codigoclaseminas
                .toLowerCase()
                .includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
      },
    });
  };

  const SeleccionarRegistros = () => {
    setActivate(true);

    let campos = "*";
    let nomtab = "claseminas";
    let orden = "idclaseminas";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setRecords(response.data);
          txtBuscador.current.focus();
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const SeleccionarRegistro = (id) => {
    setActivate(true);

    let endpoint = `${op.conexion}/api/minas/verminas/${id}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idclaseminas > 0) {
            setClase(response.data);
            setMostrar2(true);
          } else {
            setMostrar2(true);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const gestionarExpendedor = (op, id) => (e) => {
    if (op === 4) {
      if (accclaseminas.substring(0, 1) !== "0") {
        setOperacion(4);
        SeleccionarRegistro(id);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    } else if (op === 1) {
      if (accclaseminas.substring(1, 2) !== "0") {
        setOperacion(op);
        setMostrar2(true);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    } else if (op === 2) {
      if (accclaseminas.substring(2, 3) !== "0") {
        setOperacion(op);
        SeleccionarRegistro(id);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    } else if (op === 3) {
      if (accclaseminas.substring(3, 4) !== "0") {
        setOperacion(op);
        SeleccionarRegistro(id);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    }
  };

  const cerrarToast = () => {
    setToast({
      mostrar: false,
    });
  };

  const handleCancela2 = () => {
    setMostrar2(false);
  };

  const handleCloseSi = () => {
    setActivate(false);
    SeleccionarRegistro();
    setMostrar4(false);
  };

  useEffect(() => {
    SeleccionarRegistros();
    setActivate(true);
  }, []);

  return (
    <div
      className="p-0 m-0"
      style={{ backgroundColor: "#", height: "100%", width: "100%" }}
    >
      <div className="row col-md-12 py-5">
        <div className="col-md-12 p-2 mt-4">
          <div className="row col-md-12 d-flex justify-content-between">
            <input
              type="text"
              className=" col-3 form-control form-control-sm rounded-pill"
              ref={txtBuscador}
              onChange={handleSearch}
              placeholder="Buscar"
            />
            <div className="col-3 d-flex justify-content-end">
              <button
                onClick={gestionarExpendedor(1, "")}
                style={{ marginBottom: "5px" }}
                className={
                  accclaseminas.substring(1, 2) === "0"
                    ? "btn btn-sm btn-secondary rounded-circle"
                    : "btn btn-sm btn-primary rounded-circle"
                }
              >
                <i className="fas fa-plus"></i>{" "}
              </button>
            </div>
          </div>
        </div>
        <div className="col-md-12" style={{ margin: "auto" }}>
          <TblContainer>
            <TblHead />

            <TableBody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <TableRow key={index} style={{ padding: "0" }}>
                    <TableCell style={{ textAlign: "center" }}>
                      {item.idclaseminas}
                    </TableCell>
                    <TableCell style={{ textAlign: "center" }}>
                      {item.descripcion}
                    </TableCell>
                    <TableCell style={{ textAlign: "center" }}>
                      {item.codigoclaseminas}
                    </TableCell>
                    <TableCell style={{ textAlign: "center" }}>
                      <button
                        onClick={gestionarExpendedor(4, item.idclaseminas)}
                        className={
                          accclaseminas.substring(0, 1) === "0"
                            ? "btn btn-sm  btn-secondary rounded-circle ml-2"
                            : "btn btn-sm  btn-info rounded-circle ml-2"
                        }
                      >
                        <i className="fas fa-eye"></i>{" "}
                      </button>
                      <button
                        onClick={gestionarExpendedor(2, item.idclaseminas)}
                        className={
                          accclaseminas.substring(2, 3) === "0"
                            ? "btn btn-sm  btn-secondary rounded-circle ml-2"
                            : "btn btn-sm  btn-warning rounded-circle ml-2"
                        }
                      >
                        <i className="fa fa-edit"></i>{" "}
                      </button>
                      <button
                        onClick={gestionarExpendedor(3, item.idclaseminas)}
                        className={
                          accclaseminas.substring(3, 4) === "0"
                            ? "btn btn-sm  btn-secondary rounded-circle ml-2"
                            : "btn btn-sm  btn-danger rounded-circle ml-2"
                        }
                      >
                        <i className="fa fa-trash"></i>{" "}
                      </button>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </TblContainer>
          <TblPagination />
        </div>

        <ClasificadorMinas
          show={mostrar2}
          operacion={operacion}
          clase={clase}
          onHideCancela={handleCancela2}
          onHideRenderizar={SeleccionarRegistros}
        />

        <Mensaje
          mensaje={mensaje}
          onHide={() =>
            setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
        />
        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={() =>
            setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
          onHideSi={handleCloseSi}
        />
      </div>
      <Dimmer active={activate} />
      <Toasts
        show={toast.mostrar}
        titulo={toast.titulo}
        mensaje={toast.mensaje}
        onHideCancela={cerrarToast}
      />
    </div>
  );
};
export default TablaClaseMinas;



// WEBPACK FOOTER //
// ./src/components/minas/tablaClaseMinas.js